import { render, staticRenderFns } from "./TermsAndConditionsDialog.vue?vue&type=template&id=21879813"
import script from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TermsAndConditionsDialog.vue?vue&type=style&index=0&id=21879813&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports